import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Real-time listener for the current user's friends list
 * Maps each friendship doc to extract the "other user" info
 */
export function useFriendsList() {
  const { user } = useAuthContext();
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setFriends([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'friends'),
      where('uids', 'array-contains', user.uid)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const results = snapshot.docs.map((doc) => {
          const data = doc.data();
          // Extract the other user's info
          const isUid1 = data.uid1 === user.uid;
          return {
            friendshipId: doc.id,
            uid: isUid1 ? data.uid2 : data.uid1,
            username: isUid1 ? data.uid2Username : data.uid1Username,
            connectedAt: data.connectedAt,
          };
        });
        setFriends(results);
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to friends list:', err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  return { friends, loading };
}
